/* @generated */

// src/assets/ui-icon/fill/upsell.tsx
import * as React from "react";
var UpsellFill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M18.815 9.996H14.5V2.692L5.185 13.997H9.5v7.31l9.315-11.31Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  UpsellFill
};
